import React from 'react';
import { AppBar, Toolbar, Typography, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useFeatureFlags from '../../providers/FeatureFlags/FeatureFlags.provider';
import InfoIcon from '@mui/icons-material/Info';
import './TwNotificationBanner.scss';
import { useDispatch } from 'react-redux';
import { closeNotificationBanner } from '../../redux/features/navigation/navigationSlice';

export const TwNotificationBanner: React.FC = () => {
  const dispatch = useDispatch();
  const { enableNotificationBanner } = useFeatureFlags();

  const handleCloseClick = (): void => {
    dispatch(closeNotificationBanner());
  };

  if (!enableNotificationBanner?.message) return null;

  return (
    <AppBar className="tw-notification-banner__appBar">
      <Toolbar className="tw-notification-banner__toolbar">
        <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
          <InfoIcon className="tw-notification-banner__infoIcon" />
          <Typography variant="body2" className="tw-notification-banner__text">
            {enableNotificationBanner.message}
          </Typography>
        </Box>
        <IconButton edge="end" aria-label="close" onClick={handleCloseClick}>
          <CloseIcon className="tw-notification-banner__icon" />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};
